<template>
  <v-layout row wrap>
    <v-flex xs3>
      <v-text-field
        label="Cashback Limit"
        v-model="cashBackLimitAmount"
      ></v-text-field>
    </v-flex>
    <v-flex xs1></v-flex>
    <v-flex xs3>
      <v-text-field
        label="Manual Entry Limit"
        v-model="manualLimitAmount"
      ></v-text-field>
    </v-flex>
    <v-flex xs1></v-flex>
    <v-flex xs3>
      <v-text-field
        label="Swipe Limit"
        v-model="swipeLimitAmount"
      ></v-text-field>
    </v-flex>
  </v-layout>

</template>

<script>
export default {
  name: 'OrderDetailCardBrands',
  computed: {
    cashBackLimitAmount: {
      get () { return this.$store.state.order.cashBackLimitAmount },
      set (value) { this.$store.commit('updateOrder', ['cashBackLimitAmount', value]) }
    },
    manualLimitAmount: {
      get () { return this.$store.state.order.manualLimitAmount },
      set (value) { this.$store.commit('updateOrder', ['manualLimitAmount', value]) }
    },
    swipeLimitAmount: {
      get () { return this.$store.state.order.swipeLimitAmount },
      set (value) { this.$store.commit('updateOrder', ['swipeLimitAmount', value]) }
    }
  }
}
</script>

<style scoped>

</style>
